import { render, staticRenderFns } from "./IntroAdd.vue?vue&type=template&id=3b2ac6f2&"
import script from "./IntroAdd.vue?vue&type=script&lang=js&"
export * from "./IntroAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports